import(/* webpackMode: "eager" */ "/app/apps/next/app/not-found.tsx");
